import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const shareWishlistConfirmationPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("sendWishlistViaEmail/confirmation"),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/sendWishlistViaEmail/confirmation"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
